import config from '../config/index'
import { authRequest } from '../request'
import { IPaginatedParams } from '../share-types'
import { IPaginatedBillingDetailDto } from '../studios-area/pages/billing-summaries/share-type'
import qs from 'qs'

const { mainApi } = config

export type StudioBookingsQueryParams = IPaginatedParams & {
  studioIds?: number[]
  startDate: string
  endDate?: string
}

export const getStudioBookings = (params: StudioBookingsQueryParams) => {
  return authRequest.get<MISSING_TYPE, IPaginatedBillingDetailDto>(
    `${mainApi}/studios-area/bookings`,
    {
      params,
      paramsSerializer: queryParams => qs.stringify(queryParams, { arrayFormat: 'repeat' }),
    },
  )
}
